import React, { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-scroll';
import DOMPurify from 'dompurify';
//UI
import TechnicalInformation from '../../../components/yachts/TechnicalInformation';
import GuestAccommodation from '../../../components/yachts/GuestAccommodation';
import AvailableItineraries from '../../../components/yachts/AvailableItineraries';
import SocialAreas from '../../../components/yachts/SocialAreas';
import SafetyCommunications from '../../../components/yachts/SafetyCommunications';
import MainLoader from '../../../components/Loaders/MainLoader';

//SLIDER
import { getYachtByCodeThunk, initialStateYacht } from '../../../store/slices/catalogs/yachtForPage.slice';
import { API_BASE_URL } from '../../../store/constans';

const Yacht = () => {

  const { yacht_code } = useParams();
  const dispatch = useDispatch();
  const yachtState = useSelector((state) => state.yachtForPage);

  useEffect(() => {
    dispatch(getYachtByCodeThunk(yacht_code));
    return () => {
      dispatch(initialStateYacht())
    }
  }, [yacht_code])

  const navigate = useNavigate();

  const handleNavigate = useCallback((path) => {
    navigate(path);
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>{yachtState.yacht.name + " Cruise - Rolf Wittmer"}</title>
        <meta name="description" content={`Explore the Galapagos on the ${yachtState.yacht.name}, a first-class yacht for 16 passengers, offering luxury, comfort, and expert-guided wildlife tours.`} />
      </Helmet>
      {
        yachtState.fetching ?
          <MainLoader /> :
          <div name='Yacht' className='flex flex-col min-h-screen bg-fixed'>
            <div className={`flex transition-all h-screen`}>
              <img
                loading='lazy'
                className="absolute top-0 left-0 w-full h-screen object-cover"
                src={API_BASE_URL + yachtState.yacht?.image} alt={yachtState.yacht?.image} />
              <div className="absolute top-0 left-0 w-full h-full bg-black/10 "></div>
              <div className='grid grid-cols-1 md:grid-cols-2 px-5 z-10 justify-center items-center text-white w-full'>
                <div className=' z-20 mb-[-30px] flex items-center justify-center md:justify-start md:items-start md:h-[65%] md:pl-14'>
                  <p className='text-[60px] leading-none text-center text-shadow-lg uppercase font-bold'>{yachtState.yacht?.name}</p>
                </div>
                <div className=' z-20 mb-[-30px] flex flex-col justify-start items-end h-[65%]'>
                  <div className='flex flex-col mt-3 text-white gap-3 w-full md:pl-[200px]'>
                    <div className='flex flex-col items-start'>
                      <p className='text-[30px] text-shadow-lg font-semibold'>GUESTS</p>
                      <p className='text-[17px] font-sans'>{yachtState.yacht.guests}</p>
                    </div>
                    <div className='flex flex-col items-start'>
                      <p className='text-[30px] text-shadow-lg font-semibold'>CABINS</p>
                      <p className='text-[17px] font-sans '>{yachtState.yacht.cabins}</p>
                    </div>
                    <div className='flex flex-col items-start'>
                      <p className='text-[30px] text-shadow-lg font-semibold'>CREW</p>
                      <p className='text-[17px] font-sans '>{yachtState.yacht.crews}</p>
                    </div>
                  </div>
                  <div className="flex gap-3 justify-center my-3 w-full">
                    <div className="flex gap-3 justify-start">
                      <Link
                        to={'techInformation'}
                        smooth={true}
                        duration={800}
                        className="cursor-pointer transition-all hover:scale-110 shadow-md shadow-black text-[13px] md:text-[18px] border border-white px-5 py-2 font-bold rounded-full hover:text-white hover:bg-orange-500"
                      >
                        More Info
                      </Link>
                    </div>
                    <Button onClick={() => handleNavigate("/contact-us")}>Contact us</Button>
                  </div>
                </div>
              </div>
            </div>
            {Object.keys(yachtState.yacht).length !== 0 ?
              <>
                <section className='md:h-[300px] py-3 px-5 w-full flex flex-col bg-white/70 text-[#2e6a82] justify-center items-center gap-3'>
                  <h1 className=" md:text-justify text-[30px] md:text-[55px] uppercases text-shadow-lg  text-amber-500 font-semibold" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(yachtState.yacht?.title) }}></h1>
                  <p className="w-[90%] p-5 text-justify text-[18px]" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(yachtState.yacht?.text) }}></p>
                </section>
                <TechnicalInformation techInformation={yachtState.yacht.tech_info} />
                <GuestAccommodation
                  guestsAccomodation={yachtState.yacht.guests_accommodation}
                  fullScreenGalery={yachtState.yacht.full_gallery}
                  file={yachtState.yacht?.tech_info}
                  decks={yachtState.yacht.decks} />
                <AvailableItineraries yachtId={yachtState.yacht.id} />
                <SocialAreas socialAreas={yachtState.yacht.social_areas} file={yachtState.yacht?.tech_info} />
                <SafetyCommunications
                  safetyCommunication={yachtState.yacht.safety}
                  mechanicEquipment={yachtState.yacht.mechanic_equipment}
                  deckPlans={yachtState.yacht.deck_plans}
                  file={yachtState.yacht?.tech_info}
                />
              </>
              :
              <MainLoader />
            }
          </div >
      }
    </>
  );
};

const Button = ({ onClick, children }) => (
  <button
    onClick={onClick}
    className="transition-all hover:scale-110 shadow-md shadow-black text-[13px] md:text-[18px] border border-white px-5 py-2 font-bold rounded-full hover:text-white hover:bg-orange-500"
  >
    {children}
  </button>
);


export default Yacht;
